import { Component, inject, signal } from "@angular/core";
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AuthService } from "../../../../core/auth/auth.service";
import { Router } from "@angular/router";

@Component({
    selector: "app-email-password-login",
    templateUrl: "./email-password-login.component.html",
    imports: [ReactiveFormsModule, TranslatePipe]
})
export class EmailPasswordLoginComponent {
    private readonly authService = inject(AuthService);
    private readonly translateService = inject(TranslateService);

    private readonly router = inject(Router);
    private readonly fb = inject(FormBuilder);

    public isInSubmit = signal(false);
    public errorMessage = signal<string | null>(null);

    protected loginForm = this.fb.group({
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required]]
    });

    protected onSubmit() {
        if (this.loginForm.invalid) {
            return;
        }

        this.isInSubmit.set(true);
        this.errorMessage.set(null);

        const { email, password } = this.loginForm.value;

        this.authService.login({ email: email!, password: password! }).subscribe({
            next: () => {
                this.isInSubmit.set(false);
                this.router.navigate(['/dashboard']);
            },
            error: (error) => {
                this.isInSubmit.set(false);

                const translatedError = this.translateService.instant('pages.login.invalidCredentials');

                this.errorMessage.set(
                    `${translatedError} (${error.error?.message || error.message || error.statusText || 'Unknown error'})`
                );
            }
        });
    }
}